import React, { useState } from 'react';
import DefaultButton from '../ReusableComponents/DefaultButton';
import { MdRefresh } from 'react-icons/md';
import './PortalColors.css';

const defaults = { primary: '#0d6efd', accent: '#159c8b', background: '#dfe7f1', button_text: '#ffffff' };
const fields = [ ['primary', 'Cor principal', 'Links e ações principais'], ['accent', 'Cor de destaque', 'Destaques e áreas informativas'], ['background', 'Cor de fundo', 'Fundo das páginas do portal'] ];

function contrastText(color) {
  const linear = [1, 3, 5].map(start => parseInt(color.slice(start, start + 2), 16) / 255).map(value => value <= 0.04045 ? value / 12.92 : ((value + 0.055) / 1.055) ** 2.4);
  return linear.reduce((sum, value, index) => sum + value * [0.2126, 0.7152, 0.0722][index], 0) > 0.179 ? '#000000' : '#ffffff';
}

export default function PortalColors({ value }) {
  const [custom, setCustom] = useState(!!value);
  const [customText, setCustomText] = useState(!!value?.button_text);
  const [colors, setColors] = useState({ ...defaults, ...value });
  return (
    <section className="portal-form-section organization-portal-colors" aria-label="Cores do portal do aluno">
      <h3>Cores do portal do aluno</h3>
      <p className="form-text">Personalize a identidade visual do portal. As cores dos status e alertas são mantidas para facilitar a identificação.</p>
      <label className="portal-check"><input type="checkbox" checked={custom} onChange={event => setCustom(event.target.checked)} /> Personalizar as cores do portal</label>
      {!custom && <input type="hidden" name="portal_colors" value="" />}
      {custom && <>
        <div className="organization-color-grid">
          {fields.map(([key, label, description]) => <label key={key} className="organization-color-field">
            <span>{label}</span>
            <div><input type="color" name={`portal_colors[${key}]`} value={colors[key]} onChange={event => setColors({ ...colors, [key]: event.target.value })} aria-label={label} /><code>{colors[key].toUpperCase()}</code></div>
            <small className="form-text">{description}</small>
          </label>)}
        </div>
        <label className="portal-check"><input type="checkbox" checked={customText} onChange={event => setCustomText(event.target.checked)} /> Definir a cor do texto dos botões</label>
        {customText && <label className="organization-color-field organization-button-text">
          <span>Cor do texto dos botões</span>
          <div><input type="color" name="portal_colors[button_text]" value={colors.button_text || '#ffffff'} onChange={event => setColors({ ...colors, button_text: event.target.value })} aria-label="Cor do texto dos botões" /><code>{(colors.button_text || '#ffffff').toUpperCase()}</code></div>
          <small className="form-text">Aplicada aos botões com fundo colorido. Escolha uma cor com bom contraste. Sem esta opção, o portal ajusta o texto automaticamente.</small>
        </label>}
        <div className="organization-color-preview" style={{ background: colors.background }} aria-label="Prévia das cores">
          <div><strong>Portal do Aluno</strong><span style={{ borderLeftColor: colors.accent }}>Seleções e inscrições</span><span className="organization-preview-button" style={{ background: colors.primary, color: customText ? colors.button_text : contrastText(colors.primary) }}>Acessar portal</span></div>
        </div>
      </>}
      <DefaultButton type="button" text="Restaurar cores padrão" bg="secondary" icon={<MdRefresh />} onClick={() => { setCustom(false); setCustomText(false); setColors(defaults); }} />
      <small className="form-text">As alterações serão aplicadas ao salvar os dados da organizadora. Sem personalização, a paleta atual da OnTest é preservada.</small>
    </section>
  );
}
